
export const toCapitalize = (str) => {
    let lowerStr = str && str !== "" && str.toLowerCase()
    return str && str !== "" && lowerStr[0].toUpperCase() + lowerStr.slice(1);
}

export const toDisplayName = (firstName, lastName) => {
    return `${toCapitalize(firstName)} ${toCapitalize(lastName)}`
}

export const generateDisplayName = (firstName, lastName, userId) => {
    const lastNameStr = lastName ? `${lastName},` : "";
    const firstNameStr = firstName ? `${firstName} - ` : "";
    const userIdStr = userId ? `${userId}` : "N/A";
    return `${lastNameStr} ${firstNameStr} ${userIdStr}`
}

export const toCapitalizeSplitStr = (str) => {
    if (typeof str === "string") {
        const lowerStr = str.toLowerCase()
        const arr = lowerStr.split(" ");
        const _arr = arr.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        return _arr.join(" ");
    } else {
        return str
    }
}

export const toRound = (num) => {
    return Math.round((num + Number.EPSILON) * 10) / 10
}

export const formatDate = (dateStr) => {
    return dateStr && dateStr.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })
}

export const dateUntil = (dateStr) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const firstDate = new Date();
    const secondDate = new Date(dateStr);
    return Math.round(Math.abs(firstDate.setHours(0, 0, 0, 0) - secondDate.setHours(0, 0, 0, 0)) / oneDay);
}

export const dateInPastOrPresent = (dateStr) => {
    const firstDate = new Date(dateStr);
    const secondDate = new Date();
    return firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0);
}

export const isDatePastForRatings = (checkDate) => {
    const dateValues = checkDate.split('-');
    const dueDate = new Date(dateValues[0], dateValues[1] - 1, dateValues[2]);

    let diff = new Date().setHours(0, 0, 0, 0) - dueDate.setHours(0, 0, 0, 0);
    return diff > 0;
}

export const isDatePast = (checkDate) => {
    let diff = new Date().getTime() - new Date(checkDate).getTime();
    return diff > 0;
}

export const searchWithDescList = (item, searchParam, searchParamDesc = [], query) => {
    return searchParam.some((param) => {
        return (
            item[param]
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
        );
    }) || searchParamDesc.some((param) => {
        return (
            item[param] && item[param]["description"]
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
        );
    });
}

export const searchList = (item, searchParam, query) => {
    return searchParam.some((param) => {
        return (
            item[param] && item[param]
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
        );
    });
}

export const searchListWitMembers = (item, searchParam, searchParamDesc = [], query) => {
    return searchParam.some(param => {
        return (
            item[param] && item[param]
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
        );
    })
}

export const searchWithFunctionalAreaList = (item, searchParam, searchParamDesc = [], query) => {
    return searchParam.some((param) => {
        return (
            item[param]
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
        );
    }) || searchParamDesc.some((param) => {
        return (
            item[param] && item[param].map(funArea => funArea.description)
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) > -1
        );
    });
}

export const filterUnits = (feedbackArr, units) => {
    if (units.length === 0) return feedbackArr;
    else {
        const selectedUnitsData = units.map((item) => item.id)
        return feedbackArr.filter(fb => {
            return selectedUnitsData.includes(fb.stakeholder.units.length > 0 && fb.stakeholder.units[0].id)
        })
    }
}

export const filterRoles = (feedbackArr, roles) => {
    const selectedRolesData = roles.map((item) => item.id)
    return feedbackArr.filter(fb => {
        return selectedRolesData.includes(fb.stakeholder.roles && fb.stakeholder.roles[0].id)
    })
}

export const filterStakeholders = (feedbackArr, names) => {
    const selectedStakeholderNamesData = names.map((item) => item.racfID)
    return feedbackArr.filter(fb => {
        return selectedStakeholderNamesData.includes(fb.stakeholder.user.racfID)
    })
}

export const checkedData = data => {
    return data.filter(ele => {
        return ele.checked
    }).map(item => {
        return item.name
    })
}

export const sortAlphaNum = (a, b) => {
    // convert to strings and force lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a && a.toString();
    b = typeof b === 'string' ? b.toLowerCase() : b && b.toString();

    if (a === null)
        return 1;
    else if (b === null)
        return -1;
    return a.localeCompare(b);
}

export const generateFiscalYear = (currentYear) => {
    const range = (start, stop, step) => Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    return range(currentYear, currentYear + 4, 1);
}

export const isNotEmptyArray = (data) => {
    return data && data.length > 0
}

export const anyMatchInArray = (arr1, arr2) => {
    return arr1.every(element => {
        return arr2.includes(element);
    })
}

export const generateTitle = (funcAreaArr, subFuncAreaArr) => {
    let titleArr = []
    funcAreaArr.length > 0 && funcAreaArr.forEach(item => {
        const tempSFList = subFuncAreaArr.filter(ele => ele.functionalAreaId === item.id)
        const subFuncStr = tempSFList.map(sfItem => sfItem.description).join(", ")
        titleArr.push(`${item.description} - ${subFuncStr}`)
    })
    return titleArr.join("; ");
}

export const filterCriteria = (data, subCategoryId) => {
    const sortedItems = data.criteria && data.criteria.sort((a, b) => {
        let descA = a.description.toLowerCase(),
            descB = b.description.toLowerCase();
        return sortAlphaNum(descA, descB)
    })
    return sortedItems.filter(ele => ele.subCategory && ele.subCategory.id === subCategoryId)
}

export const sortCriteriaUnit = (criteria, units) => {
    const selectedUnitsData = units.map((item) => item.id)
    // JH: Feedback is not guaranteed to have a unitId (show those by default -- solution in the works)
    return criteria.map(ele => {
        return {...ele,
            feedbacks: ele.feedbacks.filter(f => {
                    return f.stakeholder?.unitId.length === 0 || f.stakeholder.unitId.reduce((val, unit) => (val || selectedUnitsData.includes(unit)), false);
                }
            )
        }
    })
}


export const sortCriteriaSupNum = (criteria, numbers) => {
    const selectedSupplierNumbers = numbers.map((item) => item.id)
    return criteria.map(ele => {
        return {...ele,
            feedbacks: ele.feedbacks.filter(f => selectedSupplierNumbers.includes(f.supplierNumber))}
    })
}

export const sortFilterRatingCriteria = (data, subCategoryId, units, supplierNumber) => {
    if(data.criteria) {
        let filteredCritera = data.criteria
        filteredCritera = sortCriteriaUnit(data.criteria, units)
        filteredCritera = sortCriteriaSupNum(filteredCritera, supplierNumber)

        const sortedItems = filteredCritera.sort((a, b) => {
            let descA = a.criteria.toLowerCase(),
              descB = b.criteria.toLowerCase();
            return sortAlphaNum(descA, descB)
        })
        return sortedItems.filter(ele => ele.subCategory && ele.subCategory.id === subCategoryId)
    }
}

export const getSelectedSubFunctionalAreas = (data, functionalAreas) => {
    const selectedFunctionalAreaIds = data && data.map(item => item.id)
    return functionalAreas.filter(ele => selectedFunctionalAreaIds.includes(ele.id)).map(item => item.subFunctionalArea)
}

export const filterFunctionalAreas = (functionalAreaArr, functionalAreas) => {
    const selectedFunctionalAreaData = functionalAreas.map((item) => item)
    return functionalAreaArr.filter(fa => {
        return selectedFunctionalAreaData.includes(fa && fa.description)
    })
}

export const getCategoryTotal = (currentData, categoryId) => {
    const filteredData = currentData.criteria.filter(ele => ele.category.id === categoryId)
    return filteredData.filter(item => item.isSelected === true).length;
}

export const getCurrentTotal = (currentData, subCategoryId) => {
    const filteredData = currentData.criteria.filter(ele => ele?.subCategory.id === subCategoryId)
    return filteredData.map(item => parseInt(item.weight)).reduce((partialSum, a) => partialSum + a, 0);
}

export const getTotalSelected = (currentData, subCategoryId) => {
    const filteredData = currentData.criteria.filter(ele => ele?.subCategory.id === subCategoryId)
    return filteredData.filter(item => item.isSelected === true).length;
}

export const getCategoryWeightTotal = (currentData, categoryId) => {
    const filteredData = currentData.category.filter(ele => ele.id === categoryId)[0].subCategories
    return filteredData.map(item => item.weight).reduce((partialSum, a) => partialSum + a, 0);
}

/**
 * @param {Array} criteriaList 
 * @param {number} categoryId 
 * @returns {number} Total points for the category
 */
export const getTotalPoints = (criteriaList, categoryId) => {
    const categoryCriteria = criteriaList && criteriaList.filter(criteria => {
        if (criteria.category.id !== categoryId || criteria.notApplicableReason)
            return false;

        if (shouldDefaultToNA(criteria))
            return false;

        return criteria.points !== null;
    });

    return categoryCriteria.map(item => item.overridePoints ?? item.points)
        .reduce((prev, curr) => prev + curr, 0);
}

/**
 * @param {Array} criteriaList 
 * @param {number} subCategoryId 
 * @returns {{ maxPointsAvailable: number, score: number }}
 */
export const getPointsForSubCategory = (criteriaList, subCategoryId) => {
    const categoryCriteria = criteriaList && criteriaList.filter(criteriaObj => {
        if (criteriaObj.subCategory.id !== subCategoryId || criteriaObj.notApplicableReason)
            return false;

        if (shouldDefaultToNA(criteriaObj, criteriaObj.feedbacks))
            return false;

        return true;
    });

    const updatedCriteriaPoints = categoryCriteria && categoryCriteria.map(item => item.overridePoints ?? item.points);
    const subCategoryTotal = updatedCriteriaPoints.reduce((prev, curr) => prev + curr, 0);
    const subCategoryWeight = categoryCriteria && categoryCriteria.reduce((total, current) => total + current.weightage, 0);

    return {
        maxPointsAvailable: subCategoryWeight,
        score: subCategoryTotal,
    };
}

/**
 * @param {Array} criteriaList 
 * @param {number} categoryId 
 * @returns {number} Total weight for the category
 */
export const getTotalWeight = (criteriaList, categoryId) => {
    const categoryCriteria = criteriaList && criteriaList.filter(criteriaItem => criteriaItem.category.id === categoryId)
    const updatedCriteriaWeightage = categoryCriteria && categoryCriteria.map(item => {
        if (item.notApplicableReason !== null)
            return 0;

        if (shouldDefaultToNA(item)) {
            return 0;
        }
        return item.weightage;
    })
    return updatedCriteriaWeightage.reduce((prev, curr) => prev + curr, 0);
}

/**
 * Checks if a non-required criteria should default to N/A based on all responses being N/A
 * @param {Object} criteria The criteria object containing isRequired and other properties
 * @returns {boolean} True if the criteria should default to N/A, false otherwise
 */
export function shouldDefaultToNA(criteria) {
    // Only apply to non-required questions
    // if (criteria.isRequired) {
    //     return false;
    // }

    return (
        !criteria.quantitativeData?.length
        && (criteria.feedbacks.every(feedback => feedback.notApplicableReason || feedback.feedback.feedbackId === null
                || feedback.feedback.notApplicable === true
                || (feedback.feedback.rating === "" && feedback.feedback.yesNoChoice === "")
            ) ||
            criteria.feedbacks.length === 0)
        && criteria.overridePoints === null
    );
};

export const validateEmbeddedLinks = (announcement) => {
    if (!announcement || announcement.trim().length === 0) {
        return false;
    }
    const regex = /\[(.*?)\]\((.*?)\)/g;
    let match;
    while ((match = regex.exec(announcement)) !== null) {
        const text = match[1];
        const link = match[2];
        if (!text || text.trim().length === 0) {
            return false;
        }
        if (!validateLink(link)) {
            return false;
        }
    }
    return true;
};

export const validateLink = (link) => {
    if (!link || !(link.startsWith("/") || link.startsWith("http") || link.startsWith("mailto"))) {
        return false;
    } else {
        return true;
    }
};

/**
 * Peek function for debugging purposes.
 * Logs a value and returns it unchanged.
 * If label is provided, it logs the label with the value.
 * @template T
 * @param {T} o Value to be logged
 * @param {string?} label Optional label for the logged value
 * @returns {T} Returns the exact same value that was passed in
 */
export function peek(o, label = null) {
    if (label) {
        console.log(label, o);
    } else {
        console.log(o);
    }
    return o;
}
